import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1043273a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["checked", "id", "required", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_3 = { class: "invalid-feedback" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.object?.Stats[_ctx.statTypeEnum.Design].Data)
    }, [
      _createElementVNode("input", {
        class: _normalizeClass(["form-check-input mt-0", _ctx.validate()]),
        type: "checkbox",
        checked: _ctx.getValue(_ctx.statTypeEnum.Value, _ctx.statTypeEnum.ValueIndices),
        id: _ctx.object?.Stats[_ctx.statTypeEnum.Tag].Data,
        required: _ctx.attributeCheck(_ctx.statTypeEnum.Required),
        disabled: _ctx.attributeCheck(_ctx.statTypeEnum.Disabled),
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.regionType.RegionTypes[_ctx.object?.Region].ObjectTypes[_ctx.object?.ObjectEnum].ChooseSubType(_ctx.object as ObjectTemplate, $event.target.checked)))
      }, null, 42, _hoisted_1),
      (_ctx.returnIfExists(_ctx.statTypeEnum.Label) !== '')
        ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.object.Stats[_ctx.statTypeEnum.Label].Data), 1))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.returnIfExists(_ctx.statTypeEnum.ErrorMessage)), 1)
  ], 64))
}